export const SET_LOADER = "SET_LOADER";
export const SET_FAILED_MSG = "SET_FAILED_MSG"
export const SET_SUCCESS_MSG = "SET_SUCCESS_MSG"